// extracted by mini-css-extract-plugin
export default {"pageTitleWrap":"PageTitle_pageTitleWrap__qhqBB","overlay":"PageTitle_overlay__SaMp+"};